import React, { useState } from "react";
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  Col,
  Divider,
} from "antd";

const { Text } = Typography;

export const TermsForm = (props) => {
  const { useForm } = props;

  return (
    <Form layout="vertical" form={useForm} style={{ margin: 30 }}>
      <Row style={{ justifyContent: "space-between" }}>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"useBorrowerCycle"}
            label={<Text>Terms Vary Based On Loan Cycle</Text>}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>

        <Divider orientation="left" orientationMargin="0">
          {" "}
          Principal
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Minimum</Text>} name={"minPrincipal"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Default</Text>} name={"principal"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Maximum</Text>} name={"maxPrincipal"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>

        <Divider orientation="left" orientationMargin="0">
          Number Of Repayments
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Minimum</Text>}
            name={"minNumberOfRepayments"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Default</Text>} name={"numberOfRepayments"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Maximum</Text>}
            name={"maxNumberOfRepayments"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>

        <Divider orientation="left" orientationMargin="0">
          Nominal Interest Rate
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Minimum</Text>}
            name={"minInterestRatePerPeriod"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Default</Text>}
            name={"interestRatePerPeriod"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Maximum</Text>}
            name={"maxInterestRatePerPeriod"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Interest Rate Frequency</Text>}
            name={"interestRateFrequencyType"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Repaid Every</Text>} name={"repaymentEvery"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name={"repaymentFrequencyType"}
            label={<Text>Repayment Frequency </Text>}
          >
            <Input
              className="of-bold-disable-input"
              options={props.repaymentFrequencyTypeOptions}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Text>
                Minimum days between disbursal <br /> and first repayment date
              </Text>
            }
            name={"minimumDaysBetweenDisbursalAndFirstRepayment"}
          >
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
